import { useTranslation } from 'react-i18next';
import { Button } from '@citiguide/ui-components';

interface EmptyFilterNoticeProps {
  onClear: () => void;
}

/** Small non-modal hint shown when an active filter leaves the viewport empty. */
export default function EmptyFilterNotice({ onClear }: EmptyFilterNoticeProps) {
  const { t } = useTranslation();
  return (
    <div
      role="status"
      style={{
        position: 'absolute',
        left: '50%',
        bottom: '24px',
        transform: 'translateX(-50%)',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        padding: '8px 12px',
        background: 'var(--surface, #fff)',
        color: 'var(--text, #222)',
        borderRadius: 'var(--radius-md, 8px)',
        boxShadow: '0 2px 8px rgba(0,0,0,0.25)',
        maxWidth: 'calc(100% - 32px)',
      }}
    >
      <span>{t('filters.noResults')}</span>
      <Button variant="ghost" size="sm" onClick={onClear}>
        {t('filters.clear')}
      </Button>
    </div>
  );
}
